const requiredEnvVars = {
  VITE_CLERK_PUBLISHABLE_KEY: import.meta.env['VITE_CLERK_PUBLISHABLE_KEY'],
  VITE_SERVER_URL: import.meta.env['VITE_SERVER_URL'],
  VITE_PAYPAL_CLIENT_ID: import.meta.env['VITE_PAYPAL_CLIENT_ID'],
  VITE_CURRENCY_API_KEY: import.meta.env['VITE_CURRENCY_API_KEY'],
  VITE_VISITOR_API_KEY: import.meta.env['VITE_VISITOR_API_KEY'],
  VITE_STRIPE_PUBLISHABLE_KEY: import.meta.env['VITE_STRIPE_PUBLISHABLE_KEY'],
  VITE_PAYMENT_PROVIDER: import.meta.env['VITE_PAYMENT_PROVIDER'],
};

const optionalEnvVars = {
  VITE_NODE_ENV: import.meta.env['VITE_NODE_ENV'] || 'development',
  VITE_GA_TRACKING_ID: import.meta.env['VITE_GA_TRACKING_ID'],
  VITE_DEFAULT_EMAIL_ADDRESS:
    import.meta.env['VITE_DEFAULT_EMAIL_ADDRESS'] || 'support@abroadly.com',
};

// Validate environment variables on module load
try {
  const missing = Object.entries(requiredEnvVars)
    .filter(([, value]) => !value)
    .map(([key]) => key);

  if (missing.length > 0) {
    throw new Error(
      `Missing required environment variables: ${missing.join(', ')}`
    );
  }
} catch (error) {
  console.error('Environment validation failed:', error);
  // In development, we might want to show a user-friendly error
  if (optionalEnvVars.VITE_NODE_ENV === 'development') {
    console.warn(
      'If you are seeing this error, please contact support with the error code: #ERROR_MISS_ENV.'
    );
  }
  throw error;
}

const env = {
  ...requiredEnvVars,
  ...optionalEnvVars,
};

export default env;
